import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Offcanvas from "react-bootstrap/Offcanvas";

import Card from "react-bootstrap/Card";
import ModalSave from "../../../common/ModalSave";
import Validation from "../../../common/FormValidation";
import { CancelButton, SaveButton } from "../../../common/Button";

import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import { Select } from "antd";

library.add(fas);

const EditOffCanvance = (props) => {
  const { postData, getData } = useContext(Context);

  const id = props.show;
  const [data, setData] = useState();

  const [formData, setFormData] = useState({
    name: "",
    price: "",
    margin_price: "",
    net_weight: "",
    hsn_code: "",
    product_category_id: null,
    product_sub_category_id: null,
  });

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [productCategory, setProductCategory] = useState([]);
  const [productSubCategory, setProductSubCategory] = useState([]);

  const handleKeyPressContact = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);

    if (!/^\d*\.?\d*$/.test(keyValue)) {
      event.preventDefault();
    }
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleCategoryChange = async (value) => {
    setFormData({
      ...formData,
      product_category_id: value,
      product_sub_category_id: null,
    });

    await getSelectedProductSubCategory(value);
  };

  const handleSubCategoryChange = (value) => {
    // find selected sub category
    const subCat = productSubCategory.find((s) => s.id === value);

    // find selected category
    const cat = productCategory.find(
      (c) => c.value === formData.product_category_id
    );

    setFormData((prev) => ({
      ...prev,
      product_sub_category_id: value,
      name: cat && subCat ? `${cat.label}-${subCat.name}` : "",
    }));
  };

  async function getSelectedProductSubCategory(id) {
    const response = await getData(`/masters/allproductsubcategory/${id}`);

    if (response.success) {
      setProductSubCategory(response.data);
    }
  }

  const GetAllProductCategory = async () => {
    const response = await getData("/masters/allproductCategory");

    const option = [];
    if (response.success) {
      response?.data?.map((data) => {
        option.push({
          value: data.id,
          name: "product_category_id",
          label: data.name,
        });
      });
    }
    setProductCategory(option);
  };

  useEffect(() => {
    GetAllProductCategory();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = Validation.FormValidation({
      classname: ".productlistclass",
    });

    if (validationErrors) {
      try {
        const response = await postData(
          `/product_management/product_list/${id}`,
          formData
        );

        if (response.success) {
          setShowModal({ code: response.code, message: response.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        } else {
          setShowModal({ code: response.code, message: response.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };

  const GetEditData = async () => {
    const response = await getData(`/product_management/product_list/${id}`);

    if (response.success) {
      setFormData(response.data);

      if (response.data.product_category_id) {
        getSelectedProductSubCategory(response.data.product_category_id);
      }
    }
  };

  useEffect(() => {
    if (id) GetEditData();
  }, [id]);

  const errorStyle = {
    color: "red",
    marginLeft: "5px",
  };

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}>
        <Offcanvas.Header closeButton>
          {/* <Offcanvas.Title>Edit Education_List</Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded">
            <Card.Body>
              <Card.Title>Edit Product</Card.Title>
              <hr />
              <Container>
                <Row>
                  <Col md={12}>
                    <Container>
                      <Row className="">
                        <Col xxl={12} xl={12} md={10}>
                          <Form
                            onSubmit={handleSubmit}
                            role="form"
                            className="productlistclass">
                            <Row>
                              <Col
                                lg={12}
                                md={12}
                                className=" mx-auto Add-content">
                                <Row>
                                  <Col md={6}>
                                    <div className="main-form-section mt-5">
                                      <Row className="row justify-content-center mb-2">
                                        <Form.Label column sm={3}>
                                          Select Product Category{" "}
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Select
                                            value={formData.product_category_id}
                                            onChange={handleCategoryChange}
                                            style={{ width: "100%" }}
                                            placeholder="Select Category">
                                            {productCategory.map((d) => (
                                              <Select.Option
                                                key={d.value}
                                                value={d.value}>
                                                {d.label}
                                              </Select.Option>
                                            ))}
                                          </Select>

                                          <span className="error-message"></span>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>

                                  <Col md={6}>
                                    <div className="main-form-section mt-5">
                                      <Row className="row justify-content-center mb-2">
                                        <Form.Label column sm={3}>
                                          Select Product SubCategory{" "}
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Select
                                            value={
                                              formData.product_sub_category_id
                                            }
                                            onChange={handleSubCategoryChange}
                                            style={{ width: "100%" }}
                                            placeholder="Select Sub Category">
                                            {productSubCategory.map((d) => (
                                              <Select.Option
                                                key={d.id}
                                                value={d.id}>
                                                {d.name}
                                              </Select.Option>
                                            ))}
                                          </Select>

                                          <span className="error-message"></span>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>

                                  <Col md={6}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Product
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                name="name"
                                                value={formData?.name}
                                                onChange={handleInputChange}
                                                placeholder="Product "
                                                id="inputEmail3"
                                                className="input-mandatory"
                                              />
                                            </InputGroup>
                                            <span className="error-message"></span>
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>

                                  <Col md={6}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Price
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="tel"
                                                name="price"
                                                value={formData?.price}
                                                onChange={handleInputChange}
                                                onKeyPress={
                                                  handleKeyPressContact
                                                }
                                                placeholder="Price "
                                                id="inputEmail3"
                                                // className="input-mandatory"
                                              />
                                            </InputGroup>
                                            {/* <span className="error-message"></span> */}
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col md={6}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Margin Price
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="tel"
                                                name="margin_price"
                                                value={formData?.margin_price}
                                                onChange={handleInputChange}
                                                onKeyPress={
                                                  handleKeyPressContact
                                                }
                                                placeholder="Margin Price "
                                                id="inputEmail3"
                                                // className="input-mandatory"
                                              />
                                            </InputGroup>
                                            {/* <span className="error-message"></span> */}
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>

                                  <Col md={6}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Net Weight(grams)
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="tel"
                                                name="net_weight"
                                                value={formData?.net_weight}
                                                onChange={handleInputChange}
                                                onKeyPress={
                                                  handleKeyPressContact
                                                }
                                                placeholder="Net Weight(grams) "
                                                id="inputEmail3"
                                                // className="input-mandatory"
                                              />
                                            </InputGroup>
                                            {/* <span className="error-message"></span> */}
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col md={6}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          HSN Code
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                name="hsn_code"
                                                value={formData.hsn_code}
                                                onChange={handleInputChange}
                                                placeholder="Product"
                                                id="inputEmail3"
                                                className="input-mandatory"
                                              />
                                            </InputGroup>
                                            <span className="error-message"></span>
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>

                                  {/* <Col md={6}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Quantity
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="tel"
                                                name="quantity"
                                                value={formData.quantity}
                                                onChange={handleChange}
                                                onKeyPress={
                                                  handleKeyPressContact
                                                }
                                                placeholder="Quantity "
                                                id="inputEmail3"
                                                className="input-mandatory"
                                              />
                                            </InputGroup>
                                            <span className="error-message"></span>
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col> */}
                                </Row>

                                <Row className="mt-5 pb-3">
                                  <div className="d-flex justify-content-center">
                                    <Link>
                                      <CancelButton
                                        name={"cancel"}
                                        handleClose={props.handleClose}
                                      />
                                    </Link>
                                    <SaveButton
                                      name={"save"}
                                      handleSubmit={handleSubmit}
                                    />
                                  </div>
                                </Row>
                              </Col>
                            </Row>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
